// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n_zy","title":"styles_title__3O9bN"};